import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../CommonModal/CommonModal';
import PaymentCalculator from '.';
import gtmBapDispatch from '../../core/gtm/gtmBapDispatch';
import themeStyles from './PaymentCalculator.styles';
import useIncentiveOffers from './ViewOffers/useIncentiveOffers';
import usePaymentCalculatorModal from './usePaymentCalculatorModal';
import { useFetchCurrentVehicleFinancialCalculatorPayment } from '../../core/apiHooks/useFetchPayment';
const PaymentCalculatorWrapper = themeStyles.apply(Box, 'PaymentCalculatorWrapper');
const PaymentCalculatorModal = ({ originalCalculatorId }) => {
    const { t } = useTranslation();
    const { modalCalculatorId, isModalOpen, closeModal, submitModalForm } = usePaymentCalculatorModal(originalCalculatorId);
    const { additionalSavingsOffers } = useIncentiveOffers(modalCalculatorId);
    const { data: termWithRateData } = useFetchCurrentVehicleFinancialCalculatorPayment(modalCalculatorId);
    const handleCloseModal = () => {
        gtmBapDispatch({
            calculatorId: modalCalculatorId,
            event: 'bap_payment_cancel',
            termWithRateData,
            additionalSavingsOffers,
        });
        closeModal();
    };
    const handleSubmitModal = () => {
        gtmBapDispatch({
            calculatorId: modalCalculatorId,
            event: 'bap_payment_confirm',
            termWithRateData,
            additionalSavingsOffers,
        });
        submitModalForm();
    };
    return (React.createElement(Box, { "data-testid": "cy-payment-calculator-modal" },
        React.createElement(CommonModal, { handleCloseModal: handleCloseModal, handleSubmit: handleSubmitModal, showModal: isModalOpen, title: t('Pages.Bap.paymentOptionsLabel'), primaryButtonText: t('Pages.Bap.okButton'), submitButtonEnabled: true },
            React.createElement(PaymentCalculatorWrapper, { "data-body-scroll-lock-ignore": true },
                React.createElement(PaymentCalculator, { id: modalCalculatorId })))));
};
export default PaymentCalculatorModal;
